import React from 'react';
import { AccountAlert } from '../../Account/Components/AccountAlert';

type HeaderType = {
	showLogo?: boolean;
	isBranded?: boolean;
};

function Header(props: HeaderType) {
	return (
		<div className={`generic-header ${props.isBranded ? 'branded' : ''}`}>
			<AccountAlert />
		</div>
	);
}

export { Header };
